import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IUnitSimActiveModel } from '@apps-common/types/management/unit'

export const QUERY_MANAGEMENT_GET_UNIT_ACTIVE = (unitId: string) => ['getUnitActive', unitId]

export const getUnitActive = async (unitId: string): Promise<IUnitSimActiveModel> =>
  axios.get(`/management/unit/getactiveunit?unitId=${unitId}`).then((res) => res.data?.data)

type QueryFnType = typeof getUnitActive

type Props = {
  config?: QueryConfig<QueryFnType>
  unitId: string
}

export const useManagementGetUnitActive = ({ config, unitId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_MANAGEMENT_GET_UNIT_ACTIVE(unitId),
    queryFn: () => getUnitActive(unitId)
  })
